import React, { forwardRef } from "react";
import { Cropper, ImageRestriction, CropperFade, CircleStencil } from "react-advanced-cropper";
import { getAbsoluteZoom, getZoomFactor } from "advanced-cropper/extensions/absolute-zoom";
import cn from "classnames";
import { Slider, Button } from "antd";
import { ZoomOutOutlined, ZoomInOutlined } from '@ant-design/icons';

// CustomCropper Component
const CustomCropper = forwardRef((props, ref) => {
  return (
    <Cropper
        ref={ref}
        imageRestriction={ImageRestriction.fitArea}
        wrapperComponent={CustomWrapper}
        style={{ height: '40vh', backgroundColor: '#fff !important', marginBottom: '32px'}}
        stencilComponent={CircleStencil}
        stencilProps={{
            aspectRatio: 1,
            movable: true,
            resizable: true,
            height: '200px',
            grid: true,
            overlayClassName: 'cropper-overlay'
        }}
      {...props}
    />
  );
});

CustomCropper.displayName = "CustomCropper";

// CustomWrapper Component
const CustomWrapper = ({ cropper, children, loaded, className }) => {
  const state = cropper.getState();
  const settings = cropper.getSettings();
  const absoluteZoom = getAbsoluteZoom(state, settings);

  const onZoom = (value, transitions) => {
    cropper.zoomImage(getZoomFactor(state, settings, value), {
      transitions: !!transitions,
    });
  };

  return (
    <CropperFade className={cn("custom-wrapper", className)} visible={state && loaded}>
      {children}
      <Navigation
        className="custom-wrapper__navigation"
        zoom={absoluteZoom}
        onZoom={onZoom}
      />
    </CropperFade>
  );
};

// Navigation Component
const Navigation = ({ className, onZoom, zoom }) => {
  const onZoomIn = () => {
    if (onZoom && isNumber(zoom)) {
      onZoom(Math.min(1, zoom + 0.25), true);
    }
  };

  const onZoomOut = () => {
    if (onZoom && isNumber(zoom)) {
      onZoom(Math.max(0, zoom - 0.25), true);
    }
  };

  return (
    <div className={cn("absolute-zoom-cropper-navigation", className)} style={{ display: 'flex', width: '100% !important', marginTop: '32px' }}>
      <Button shape="circle" className="absolute-zoom-cropper-navigation__button" onClick={onZoomOut} icon={<ZoomOutOutlined />} style={{ marginRight: '10px' }} />
      <Slider
        value={zoom}
        onChange={(value) => onZoom && onZoom(value, true)}
        className="absolute-zoom-cropper-navigation__slider"
        min={0}
        max={1}
        step={0.01}
        style={{ width: '50%' }}
      />
      <Button shape="circle" className="absolute-zoom-cropper-navigation__button" onClick={onZoomIn} icon={<ZoomInOutlined />} style={{ marginLeft: '10px' }} />
    </div>
  );
};

const isNumber = (value) => {
  return typeof value === 'number' && !isNaN(value);
};

export { CustomCropper, CustomWrapper, Navigation };
